
<div class="alert-div alert-div-warning d-flex flex-wrap mt-2 mb-4">
    <div class="content-w mx-2 d-flex flex-column align-items-start">
        <div class="d-flex text-start">
            <div class="icon-w">
                <img src="assets/img/ring.svg" alt="">
            </div>
            <span class="yellow-text mx-1 font-600">
                {{'IPOAlertTitle' | translate}}
            </span>
        </div>
        <span class="alert-desc-color text-start  font-small mx-4">
            {{'wayToBuyAlert' | translate}}
        </span>
    </div>
</div>

<div class="IPO-card my-2" >
    <div class="my-3 text-color-theme font-medium font-600 text-start">{{'fact-sheet'|translate}}</div>
    <ng-container >
        <div class="row">
            <!-- *ngIf="fundDetails?.RiskProfileAR || fundDetails?.RiskProfileEN" -->
            <div  class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="IPO-card IPO-unselected-card px-3 my-2">
                    <div class="d-flex">
                        <div class="mx-2 d-flex flex-column align-items-start">
                            <span class="text-nowrap dimmed-title-2 font-600">
                                {{'risk-profile'|translate}}
                                <span>
                                    <hint-popover [key]="'risk-profile-desc'" [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                                </span>
                            </span>
                            <span class="text-highlight-company-color font-medium font-600">{{lang == 'en' ? fundDetails?.RiskProfileEN : fundDetails?.RiskProfileAR}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- *ngIf="fundDetails?.SubscriptionFrequencyAr || fundDetails?.SubscriptionFrequencyEn" -->
            <div  class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="IPO-card  IPO-unselected-card px-3 my-2">
                    <div class="d-flex">
                        <div class="mx-2 d-flex flex-column align-items-start">
                            <span class="text-nowrap dimmed-title-2 font-600">
                                {{'subscription-freq'|translate}}
                                <span>
                                    <hint-popover [key]="'subscription-freq-desc'" [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                                </span>
                            </span>
                            <span class="text-highlight-company-color font-medium font-600">{{lang == 'en' ? fundDetails?.SubscriptionFrequencyEn: fundDetails?.SubscriptionFrequencyAr }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <!--  *ngIf="fundDetails?.PercentValue"  -->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="IPO-card  IPO-unselected-card px-3 my-2">
                    <div class="d-flex">
                        <div class="mx-2 d-flex flex-column align-items-start">
                            <span class="text-nowrap dimmed-title-2 font-600">
                                {{'expense-ratio'|translate}}
                                <span>
                                    <hint-popover [key]="'expense-ratio-desc'" [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                                </span>
                            </span>
                            <span class="text-highlight-company-color font-medium font-600">{{fundDetails?.PercentValue |numberFormat }} %</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- *ngIf="fundDetails?.RedemptionFrequencyAr || fundDetails?.RedemptionFrequencyEn" -->
            <div  class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="IPO-card  IPO-unselected-card px-3 my-2">
                    <div class="d-flex">
                        <div class="mx-2 d-flex flex-column align-items-start">
                            <span class="text-nowrap dimmed-title-2 font-600">
                                {{'redemption-freq'|translate}}
                                <span>
                                    <hint-popover [key]="'redemption-freq-desc'" [iconColor]="isDarkTheme?'#dedede':'lightslategray'"></hint-popover>
                                </span>
                            </span>
                            <span class="text-highlight-company-color font-medium font-600">{{lang =='en'? fundDetails?.RedemptionFrequencyEn : fundDetails?.RedemptionFrequencyAr}} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
<div class="d-flex flex-wrap flex-column w-100 IPO-card mt-4">
    <div class="d-flex flex-column align-items-start text-color-theme font-medium mx-3 font-600">{{ "pdf" | translate }}</div>
    <div class="d-flex flex-wrap justify-content-center my-2">
        <ng-container *ngIf="fundDetails?.PdfsUrlsList?.length>0" >
            <div class="row w-100" *ngFor="let i of getRowIndexes(fundDetails?.PdfsUrlsList?.length)">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngIf="fundDetails?.PdfsUrlsList[i]" >
                    <div class="pdf-card clickable my-2">
                        <a target="_blank" class="d-flex flex-column align-items-center justify-content-center my-2 text-color-theme font-small font-600" [href]="fundDetails?.PdfsUrlsList[i]"  >
                            <img src="assets/img/PDF.svg" alt="">
                            {{'attachment' | translate}} {{1}}
                        </a>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngIf="fundDetails?.PdfsUrlsList[i+1]">
                    <div class="pdf-card clickable my-2">
                        <a target="_blank" class="d-flex flex-column align-items-center justify-content-center my-2 text-color-theme font-small font-600" [href]="fundDetails?.PdfsUrlsList[i+1]">
                            <img src="assets/img/PDF.svg" alt="">
                            {{'attachment' | translate}} {{2}}
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!fundDetails?.PdfsUrlsList">
            <div  class="col-12">
                <div class="pdf-card my-2 d-flex flex-column align-items-center justify-content-center">
                    <img src="assets/img/noPdfFound.png">
                    <div class="my-2 font-small no-data-available mt-2 font-600">{{ "noPDF" | translate }}</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>